export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Parent"
};